import styled from 'styled-components'

export default styled.div`
  display: flex;
  width: 100%;

  & > *:not(:last-child) {
    margin-right: 20px;
  }
`



// WEBPACK FOOTER //
// ./src/components/form/FieldGroup.js